export const getters = {
  getFunnels: state => Object.values(state.records),

  getFunnel: state => funnelId => state.records[funnelId],

  getSelectedFunnelId: state => state.selectedFunnelId,

  getSelectedFunnel: state => {
    if (!state.selectedFunnelId) return null;
    return state.records[state.selectedFunnelId];
  },

  getStageState: state => state.stageState || {},

  getFunnelsByType: state => funnelType => {
    return Object.values(state.records).filter(
      funnel => funnel.funnel_type === funnelType
    );
  },

  getFunnelStages: state => funnelId => {
    const funnel = state.records[funnelId];
    if (!funnel?.stages) return [];

    return Object.entries(funnel.stages)
      .map(([name, config]) => ({
        name,
        ...config,
      }))
      .sort((a, b) => (a.position || 0) - (b.position || 0));
  },

  getFunnelStageByName: state => (funnelId, stageName) => {
    const funnel = state.records[funnelId];
    if (!funnel?.stages?.[stageName]) return null;

    return {
      name: stageName,
      ...funnel.stages[stageName],
    };
  },

  getOrderedStages: state => funnelId => {
    const funnel = state.records[funnelId];
    if (!funnel?.stages) return [];

    return Object.entries(funnel.stages)
      .sort((a, b) => (a[1].position || 0) - (b[1].position || 0))
      .map(([name, config]) => ({ name, ...config }));
  },

  getFunnelTemplates: state => state.templates,

  getTemplateByType: state => templateType => {
    return state.templates.find(template => template.type === templateType);
  },

  // UI Flags
  getUIFlags: state => state.uiFlags,

  isFetching: state => state.uiFlags.isFetching,
  isCreating: state => state.uiFlags.isCreating,
  isUpdating: state => state.uiFlags.isUpdating,
  isDeleting: state => state.uiFlags.isDeleting,

  // Statistics
  getFunnelCount: state => Object.keys(state.records).length,

  getFunnelStats: state => funnelId => {
    const funnel = state.records[funnelId];
    if (!funnel?.stages) return null;

    const stages = Object.keys(funnel.stages);
    return {
      totalStages: stages.length,
      // Estatísticas adicionais podem ser adicionadas aqui
    };
  },

  // Validation
  getFunnelById: state => id => {
    return state.records[id] || null;
  },

  canDeleteFunnel: state => funnelId => {
    // Pode adicionar lógica de validação aqui
    // Por exemplo: verificar se há conversas associadas
    return !state.uiFlags.isDeleting;
  },

  isValidStageName: state => (funnelId, stageName) => {
    const funnel = state.records[funnelId];
    if (!funnel) return false;

    // Verificar se o nome da etapa já existe
    return !funnel.stages || !funnel.stages[stageName];
  },

  // Search and filter
  searchFunnels: state => searchTerm => {
    if (!searchTerm) return Object.values(state.records);

    const term = searchTerm.toLowerCase();
    return Object.values(state.records).filter(
      funnel =>
        funnel.name.toLowerCase().includes(term) ||
        funnel.description?.toLowerCase().includes(term) ||
        funnel.funnel_type.toLowerCase().includes(term)
    );
  },
};
